// extracted by mini-css-extract-plugin
export default {"outerContainer":"sP2zb","sizing":"T8tvt","double":"Ulc4D","imageContainer":"PiGyG","imageBackground":"pJbez","image":"y0l9c"};